// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"317":"4120bd79","764":"8073e95e"}[chunkId] + ".chunk.css";
};